





























































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import { AppMenus as _menu } from '@/shared/app.menu';
import LeftNavigationComponent from "../Workspace/Components/LeftNavigation.vue";
import BackButton from "@/components/common/Buttons/BackButton.vue"
import ReportSummaryComponent from "./Reports/Summary.vue";
import ReportComponent from "./Reports/Report.vue";
import { AppConstants as _app } from '@/shared/app.constants';
import { CommunicationData } from "@/entities";
import AuthService from "@/services/auth.service";
import { User } from "oidc-client";
const auth = new AuthService();
const namespace: string = "communication";

@Component ({
  components: {
      LeftNavigationComponent,
      ReportSummaryComponent,
      ReportComponent,
      BackButton
  }
})
export default class CommunicationWorkspaceComponent extends Vue {

    @State(namespace) comm!: CommunicationData;
    @Action("getCommunication", { namespace }) getCommunication: any;
    @Action("updateReport", { namespace }) updateReport: any;    
    @Getter("sections", { namespace }) subSections: any;

    docTags: any = [];
    showSideBar = true;
    isDirty = false;
    techReports = [];
    actions = _app.actions;
    subjects = _app.subjects;    
    initiativeId:number = 0;
    reportKey: number = 0;
    routeChangeCount: number = 0;
    role_id: any;

    mounted() {
        auth.isLoggedIn().then((isLoggedIn) => {
        if (isLoggedIn) {
              auth.getUser().then((user: User) => {                
                this.role_id = user.profile.role_id;                                    
              });
          }          
      });
    }

    downloadPdf() {      
    }   
    
    // default back button if route not exists..
    back() {
        this.$router.push({
            name: "Grants"
        });
    }

    // get the report workflow info
    getReportWorkflow(key) {
        return this.comm.workflowData.ChildSteps.find(x => x.StepId === key) || {};
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.comm.selectedKey = key;
        window.location.hash = `#${this.comm.selectedKey}`;
        this.routeChangeCount += 1;
        this.isDirty = false;
    }

    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    // #. save the active tab
    saveCommunication() {        
        var report = this.comm.reports.find(x => x.StepId == this.comm.selectedKey);
        if(report) {
            this.updateReport(report)
            .then(() => {
                this.reportKey += 1;
                this.isDirty = false;
            })
        }
    }

    
    /** watch method to refresh page on page load */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
        if(changedRoute && changedRoute.name === 'communicationReports') {

            const commId = changedRoute.params.communicationId;            

            // Added this condition to hadle the route change on hash value update
            if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.communicationId !== previousRoute.params.communicationId ) {
                this.getCommunication(commId).then((resp) => {
                    if(this.$route.hash)
                        this.comm.selectedKey = this.$route.hash.substr(1);
                    else
                        window.location.hash = `#${this.comm.selectedKey}`;
                })               
            }
        }
    }
    
}
